import { Config } from "./config";
export const Authentication_Apis = {
    GetEmployeeInfo_API: `${Config.server_url}${Config.api_prefix}/Employee/GetEmployeeInfo`,
};
